import { EventStatus, UserRole } from './types';

export const USER_ROLES: Record<UserRole, UserRole> = {
  Admin: 'Admin',
  Moderator: 'Moderator',
  Organizer: 'Organizer',
  VerifiedOrganizer: 'VerifiedOrganizer',
};

export const USER_ROLES_LIST: UserRole[] = Object.values(USER_ROLES);

export const EVENT_STATUSES: EventStatus[] = [
  'WaitingForReview',
  'WaitingForRefinement',
  'Approved',
  'Rejected',
  'Cancelled',
];

export const sessionStorageTokenKey = 'podiya-token';
export const sessionStorageUserDataKey = 'user-data';
export const localStorageIdTokenKey = 'podiya-id-token';

export const REPEATED_EVENT_FREQUENCY = {
  everyday: 'd',
  everyweek: 'w',
};
